export const SERVICE_KIND_OPERATION = 'operation';

export const SURGERY_MODE_AMBULATORY = 'ambulatory';
export const SURGERY_MODE_INPATIENT = 'inpatient';
export const SURGERY_BOARD_DRESSING = 'dressing';

export const SURGERY_MODE_LABELS = {
  [SURGERY_MODE_AMBULATORY]: 'Амбулаторная операция',
  [SURGERY_MODE_INPATIENT]: 'Стационарная операция',
  [SURGERY_BOARD_DRESSING]: 'Перевязки',
};

export const SURGERY_BOOKING_KIND_OPERATION = 'operation';
export const SURGERY_BOOKING_KIND_DRESSING = 'dressing';

export const CARE_TYPE_OUTPATIENT = 'outpatient';
export const CARE_TYPE_INPATIENT = 'inpatient';

export function isDressingService(service) {
  if (!service) return false;
  const name = String(service.name ?? service.serviceName ?? service.service_name ?? '').toLowerCase();
  return name.includes('перевяз');
}

export function isOperationService(service) {
  if (!service) return false;
  const kind = service.serviceKind ?? service.service_kind ?? '';
  return kind === SERVICE_KIND_OPERATION && !isDressingService(service);
}

export function surgeryCareTypeForMode(mode) {
  return mode === SURGERY_MODE_INPATIENT ? CARE_TYPE_INPATIENT : CARE_TYPE_OUTPATIENT;
}

export function formatSurgeryVisitLabel(booking) {
  const dressing = isDressingService({
    name: booking?.serviceName ?? booking?.service_name,
  });
  const n = dressing
    ? booking?.surgerySequence ?? booking?.surgery_sequence ?? booking?.visitNumber
    : booking?.surgeryRegisterNumber ??
      booking?.surgery_register_number ??
      null;
  const prefix = dressing ? 'Перевязка' : 'Операция';
  return n ? `${prefix} ${n}` : dressing ? 'Перевязка' : 'Операция';
}

export function surgeryBoardItemMatchesTab(item, boardMode) {
  const dressing = isDressingService({ name: item?.serviceName ?? item?.service_name });
  if (boardMode === SURGERY_BOARD_DRESSING) {
    return dressing;
  }
  if (boardMode === SURGERY_MODE_INPATIENT) {
    return (item?.surgeryMode ?? item?.surgery_mode) === SURGERY_MODE_INPATIENT && !dressing;
  }
  return (item?.surgeryMode ?? item?.surgery_mode) !== SURGERY_MODE_INPATIENT && !dressing;
}

export function defaultOperationForm() {
  return {
    name: '',
    price: '',
    duration: 60,
    doctorProfitPercent: 50,
    categoryId: '',
  };
}

export function buildOperationPayload(form, careType = CARE_TYPE_OUTPATIENT) {
  return {
    name: String(form.name || '').trim(),
    careType,
    price: Number(form.price) || 0,
    duration: Number(form.duration) || 60,
    doctorProfitPercent: Number(form.doctorProfitPercent ?? form.doctor_profit_percent ?? 50),
    categoryId: form.categoryId || form.category_id || null,
    serviceKind: SERVICE_KIND_OPERATION,
  };
}

export function surgeryMedicalRecordPath(booking) {
  const clientId = booking?.clientId ?? booking?.client_id;
  if (!clientId) return null;
  const bookingId = booking?.id;
  if (isDressingService({ name: booking?.serviceName ?? booking?.service_name })) {
    return bookingId
      ? `/admin/medical-records/${clientId}?bookingId=${bookingId}`
      : `/admin/medical-records/${clientId}`;
  }
  const params = new URLSearchParams();
  if (bookingId) params.set('bookingId', String(bookingId));
  params.set('tab', 'history');
  return `/admin/medical-records/${clientId}?${params.toString()}`;
}
